// extracted by mini-css-extract-plugin
export default {"iconWrap":"tree-select_iconWrap__KnI9l","folder":"tree-select_folder__bvl7+","arrowIcon":"tree-select_arrowIcon__3Lokl"};